import { render } from "./C13.vue?vue&type=template&id=25996f6a&scoped=true"
import script from "./C13.vue?vue&type=script&lang=js"
export * from "./C13.vue?vue&type=script&lang=js"

import "./C13.vue?vue&type=style&index=0&id=25996f6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25996f6a"]])

export default __exports__